import React from 'react';

type AlertType = 'success' | 'warning' | 'error' | 'info';

const Icon: React.FC<{ type: AlertType }> = ({ type }) => {
  switch (type) {
    case 'success':
      return <Success />;
    case 'warning':
      return <Warning />;
    case 'error':
      return <Error />;
    default:
      return <Info />;
  }
};

const Success = () => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="check-circle"
    width="1em"
    height="1em"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="m6.562 14.264 3.248 3.145 8.78-10.348"
      strokeLinecap="round"
      stroke="#fff"
    ></path>
  </svg>
);

const Info = () => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="info-circle"
    width="1em"
    height="1em"
    fill="#1890ff"
    aria-hidden="true"
  >
    <path
      d="M14.75 7.22498C14.75 5.43005 13.2949 3.97498 11.5 3.97498C9.70507 3.97498 8.25 5.43005 8.25 7.22498H6.08333H5.5C5.22386 7.22498 5 7.44883 5 7.72498V7.80831C5 8.08445 5.22386 8.30831 5.5 8.30831H6.08333V18.0583C6.08333 19.2549 7.05338 20.225 8.25 20.225H14.75C15.9466 20.225 16.9167 19.2549 16.9167 18.0583V8.30831H17.5C17.7761 8.30831 18 8.08445 18 7.80831V7.72498C18 7.44883 17.7761 7.22498 17.5 7.22498H16.9167H14.75ZM11.6617 5.06425C12.7828 5.14696 13.6667 6.08275 13.6667 7.22498H9.33333L9.33928 7.06327C9.42199 5.94218 10.3578 5.05831 11.5 5.05831L11.6617 5.06425ZM7.16667 8.30831H8.25H14.75H15.8333V18.0583L15.826 18.1846C15.7635 18.7234 15.3056 19.1416 14.75 19.1416H8.25L8.12366 19.1344C7.58488 19.0718 7.16667 18.6139 7.16667 18.0583V8.30831ZM9.29167 10.475C9.01552 10.475 8.79167 10.6988 8.79167 10.975V15.3916C8.79167 15.6678 9.01552 15.8916 9.29167 15.8916H9.375C9.65114 15.8916 9.875 15.6678 9.875 15.3916V10.975C9.875 10.6988 9.65114 10.475 9.375 10.475H9.29167ZM13.625 10.475C13.3489 10.475 13.125 10.6988 13.125 10.975V15.3916C13.125 15.6678 13.3489 15.8916 13.625 15.8916H13.7083C13.9845 15.8916 14.2083 15.6678 14.2083 15.3916V10.975C14.2083 10.6988 13.9845 10.475 13.7083 10.475H13.625ZM10.9583 10.975C10.9583 10.6988 11.1822 10.475 11.4583 10.475H11.5417C11.8178 10.475 12.0417 10.6988 12.0417 10.975V16.475C12.0417 16.7511 11.8178 16.975 11.5417 16.975H11.4583C11.1822 16.975 10.9583 16.7511 10.9583 16.475V10.975Z"
      strokeLinecap="round"
      fill="#fff"
    ></path>
  </svg>
);

const Warning = () => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="exclamation-circle"
    width="1em"
    height="1em"
    fill="#faad14"
    aria-hidden="true"
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path>
  </svg>
);

const Error = () => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="close-circle"
    width="1em"
    height="1em"
    fill="#ff4d4f"
    aria-hidden="true"
  >
    <path
      d="M19.778 4.222 4.22 19.778M4.222 4.222l15.556 15.556"
      strokeLinecap="round"
      stroke="#fff"
    ></path>
  </svg>
);

export default Icon;
